export default function VideoModal({ videoId, onClose }) {
  if (!videoId) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-2xl md:max-w-3xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute -top-6 right-0 md:-top-10 text-white text-4xl hover:scale-110 transition"
          aria-label="Close"
        >
          ×
        </button>

        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
          allow="autoplay; encrypted-media; fullscreen"
          allowFullScreen
          className="w-full aspect-video rounded-lg"
        />
      </div>
    </div>
  );
}
